import { useState } from "react";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { Membership } from "@/components/landing/Membership";
import { FoundingBand } from "@/components/landing/FoundingBand";
import { Results } from "@/components/landing/Results";
import { WhyDark } from "@/components/landing/WhyDark";
import { FAQ } from "@/components/landing/FAQ";
import { RequestForm } from "@/components/landing/RequestForm";
import { Footer } from "@/components/landing/Footer";
import { StickyCta } from "@/components/landing/StickyCta";
import { Reveal } from "@/components/landing/Reveal";

const PhilosophyLine = ({ text, testid }) => (
  <div className="py-24 sm:py-36 px-5 sm:px-8" data-testid={testid}>
    <Reveal>
      <p className="font-display italic text-2xl sm:text-4xl text-silver/70 text-center max-w-3xl mx-auto leading-snug">
        {text}
      </p>
    </Reveal>
  </div>
);

export default function Landing() {
  const [serviceInterest, setServiceInterest] = useState("");

  return (
    <div className="grain" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Services onSelect={setServiceInterest} />
        <PhilosophyLine
          text="How you maintain what you own says something before you speak."
          testid="philosophy-line-1"
        />
        <Membership onApply={setServiceInterest} />
        <FoundingBand onApply={setServiceInterest} />
        <Results />
        <WhyDark />
        <FAQ />
        <RequestForm serviceInterest={serviceInterest} />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
